import React from "react";

export default () => {
  return (
    <div>
      <h1>Version 2</h1>
      <p> Hello World</p>
    </div>
  );
};
